export const changeFobPriceValueReducer = (state = '', action) => {
    switch (action.type) {
      case "CHANGE_FOB_PRICE_VALUE":
        return action.payload.fobPriceValue;
      default:
        return state;
    }
  };
  